<template>
    <div class="tbl-contents-container">
        <fieldset class="tbl-filters">
            <div class="search-bar">
                <input type="search"
                    :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                    v-model="searchTxt"
                    @keyup="debounceSearchText">
                <i class="icon"></i>
                <button type="button"
                    class="buttons-icon"
                    data-type="ghost" data-size="s"
                    data-icon="clear"
                    @click="resetSearchText">Reset</button>
            </div>
        </fieldset>
        <p class="tbl-message">
            {{ $t('COMPLIANCE.LABEL.EA_SELECTED', {'cnt': checkAcntList.length})}}<!--ea selected-->
        </p>
        <table class="tbl-default" data-scrollable>
            <colgroup>
                <col style="width: 50px;">
                <col>
            </colgroup>
            <thead>
            <tr>
                <th class="txt-c" data-size="checkbox">
                    <input type="checkbox"
                        id="checkAll" 
                        v-model="checkAll"
                    >
                </th>
                <th scope="col" colspan="2">
                    <button type="button"
                        class="buttons-tbl-header"
                        :data-type="sortColumn !== 'accId' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                        @click="setSortColumn('accId')">
                        {{$t('COMPLIANCE.WHITELIST.HEADER.ACCOUNT_NAME')}}
                    </button>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="acnt in getAcntList"
                class="{'selected' : checkRow(acnt.accId)}"
                :key="acnt.accId">
                <td class="txt-c" data-size="checkbox">
                    <input type="checkbox"
                        name="compliance-popup-account"
                        class="checkbox txt-none"
                        v-bind:id="acnt.accId"
                        v-bind:value="acnt.accId"
                        v-model="checkAcntList">
                    <label :for="acnt.accId">{{$t('LABEL.SELECT')}}</label>
                </td>
                <td>
                    <span :data-vendor="Common.getVendorByKey(acnt.vendor)"
                    class="icon-vender" data-size="s"/>
                    <span>
                        {{acnt.accId}} | {{acnt.accAlias}}
                    </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "SetCmplAcntForm",
    data() {
        return {
            checkAcntList: [],
            checkAll: false,
            sortColumn: "",
            searchTxt: "",
            sortOrder: ""
        }
    },
    props: {
        acntList: {
            type: Array,
            default: ()=>{return []},
        },
        selectedAcntList: {
            type: Array,
            default: ()=>{return []},
        },
        callSetSelectedAcntList: {
            type: Function,
            default: ()=>{}
        },
        callCheckAll: {
            type: Function,
            default: ()=>{}
        },
        callSetSearchTxt: {
            type: Function,
            default: ()=>{}
        },
    },
    created: function() {
        this.debounceSearchText = _.debounce(this.searchText, 1000);
    },
    methods: {
        setSortColumn(sortColumn) {
            if (this.sortColumn !== sortColumn) {
                this.sortColumn = sortColumn
                this.sortOrder = 'asc'
            } else if (this.sortColumn === sortColumn && this.sortOrder === 'asc') {
                this.sortOrder = 'desc'
            } else if (this.sortColumn === sortColumn && this.sortOrder === 'desc') {
                this.sortColumn = ''
                this.sortOrder = ''
            }
        },
        searchText() {
            this.callSetSearchTxt(this.searchTxt);
        },
        resetSearchText() {
            this.searchTxt = "";
            this.callSetSearchTxt(this.searchTxt);
        }
    },
    computed: {
        getAcntList() {
            let filtered = _.cloneDeep(this.acntList);
            // Sorting 처리
            if (this.sortColumn !== '' && this.sortOrder !== '') {
                filtered = _.orderBy(filtered, [this.sortColumn], [this.sortOrder])
            }
            return filtered;
        },
    },
    mounted() {
        this.checkAcntList = this.selectedAcntList;
        if (this.selectedAcntList.length === this.acntList.length) {
            this.checkAll = true;
        }
    },
    watch: {
        selectedAcntList(newVal, olv) {
            this.checkAcntList = newVal;
            if (newVal.length === this.acntList.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },
        checkAcntList(newVal, olv) {
            this.callSetSelectedAcntList(this.checkAcntList);
        },
        checkAll(newVal, olv) {
            if (newVal) {
                this.callCheckAll(newVal);
            } else if (this.checkAcntList.length === 0 || this.checkAcntList.length === this.acntList.length) {
                this.callCheckAll(newVal);
            }
        }
    }
}
</script>
<style scoped>
input#checkAll {
    height: 15px;
    width: 15px;
    vertical-align: middle;
    border: 1px solid #D5D9DB;
    border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/compliance/components/SetCmplAcntForm.vue